module.exports = __webpack_public_path__ + "img/onTrial.4f22cd01.png";